/**
 * Legacy ImportExportsApiService module — preserved as an empty AngularJS
 * module so existing dependencies (`acme.common.service.importExportsApi`)
 * keep resolving.
 *
 * The actual `ImportExportsApiService` is now an Angular 18 class registered
 * as a downgraded factory under the same name in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * Implementation:
 *   apps/b2b-frontend/app/core/api/import-exports/import-exports-api.service.ts
 *
 * Do NOT register `.provider('ImportExportsApiService', ...)` here — it would
 * shadow the downgraded service.
 */
angular.module('acme.common.service.importExportsApi', []);
